export const books = [
  // PHYSICAL SCIENCES (Grades 10–12)
  {
    id: "book-ps-10",
    title: "Physical Sciences Grade 10",
    description: "Comprehensive guide for Grade 10 Physical Sciences aligned with the curriculum.",
    price: 225,
    grade: 10,
    subject: "Physical Sciences",
    category: "assessment",
    coverUrl: "/media/img/PBbooks.png",
    type: "book",
  },
  {
    id: "book-ps-11",
    title: "Physical Sciences Grade 11",
    description: "Detailed explanations and practice for Grade 11 Physical Sciences.",
    price: 225,
    grade: 11,
    subject: "Physical Sciences",
    category: "assessment",
    coverUrl: "/media/img/PBbooks.png",
    type: "book",
  },
  {
    id: "book-ps-12",
    title: "Physical Sciences Grade 12",
    description: "Extensive preparation for final exams with Grade 12 Physical Sciences.",
    price: 325,
    grade: 12,
    subject: "Physical Sciences",
    category: "assessment",
    coverUrl: "/media/img/PBbooks.png",
    type: "book",
  },

  // MATHEMATICS (Grades 8–12)
  {
    id: "book-math-7",
    title: "Mathematics Grade 7",
    description: "Build a strong foundation in Mathematics for Grade 8.",
    price: 200,
    grade: 7,
    subject: "Mathematics",
    category: "assessment",
    coverUrl: "/media/img/grade10.png",
    type: "book",
  },
  {
    id: "book-math-8",
    title: "Mathematics Grade 8",
    description: "Build a strong foundation in Mathematics for Grade 8.",
    price: 200,
    grade: 8,
    subject: "Mathematics",
    category: "assessment",
    coverUrl: "/media/img/grade10.png",
    type: "book",
  },
  {
    id: "book-math-9",
    title: "Mathematics Grade 9",
    description: "Master key concepts and practice problems for Grade 9 Mathematics.",
    price: 200,
    grade: 9,
    subject: "Mathematics",
    category: "assessment",
    coverUrl: "/media/img/grade10.png",
    type: "book",
  },
  {
    id: "book-math-10",
    title: "Mathematics Grade 10",
    description: "Comprehensive content for Grade 10 Mathematics.",
    price: 225,
    grade: 10,
    subject: "Mathematics",
    category: "assessment",
    coverUrl: "/media/img/grade10.png",
    type: "book",
  },
  {
    id: "book-math-11",
    title: "Mathematics Grade 11",
    description: "In-depth guide for Grade 11 Mathematics with solved examples.",
    price: 225,
    grade: 11,
    subject: "Mathematics",
    category: "assessment",
    coverUrl: "/media/img/grade10.png",
    type: "book",
  },
  {
    id: "book-math-12",
    title: "Mathematics Grade 12",
    description: "Prepare for Grade 12 exams with advanced Mathematics practice.",
    price: 300,
    grade: 12,
    subject: "Mathematics",
    category: "assessment",
    coverUrl: "/media/img/grade10.png",
    type: "book",
  },

  // PUBLISHED BOOKS
  {
    id: "book-pb-01",
    title: "Coronared, Dr. Morris SPK Madzime",
    description: 'This informative and easy to understand book, seeks to put critical information about COVID-19 at the disposal of the average person. As the adage goes, “knowledge is power"',
    price: 300,
    grade: null,
    subject: "Published",
    category: "published",
    coverUrl: "/media/img/Coronared.jpeg",
    type: "book",
  },
  
];